import * as yup from 'yup';

const getOperationsForCategory = (allCrops, category) =>
  allCrops?.flatMap((crop) =>
    crop.operations
      .filter((operation) => operation.category === category)
      .map((op) => ({ ...op, crop })),
  );

const getDeveloperAssignedOperationsForCategory = (allCrops, category) =>
  getOperationsForCategory(allCrops, category).filter(
    ({ assignment }) => assignment === 'developer',
  );

const getDeveloperAssignedCapexes = (allCapexes) =>
  allCapexes.filter(({ assignment }) => assignment === 'developer');

export const ADJUSTMENT_TYPES = {
  buffer: {
    percentToMultiplier: (percent) => 1 + percent * 0.01,
    percentValidator: yup.number().min(0, 'Min 0'),
    description: `Costs for genetic stock, capital expenses, and developer assigned
              operations will be increased based on buffer settings`,
    getOperationsForCategory: getDeveloperAssignedOperationsForCategory,
    getCapexesForOverride: getDeveloperAssignedCapexes,
  },
  margin: {
    percentToMultiplier: (percent) => 1 / (1 - percent * 0.01),
    percentValidator: yup.number().min(0, 'Min 0').lessThan(100, 'Max 100'),
    description: `Costs for genetic stock, capital expenses, and developer assigned
              operations will be increased based on margin settings`,
    getOperationsForCategory: getDeveloperAssignedOperationsForCategory,
    getCapexesForOverride: getDeveloperAssignedCapexes,
  },
  subsidy: {
    percentToMultiplier: (percent) => 1 - percent * 0.01,
    percentValidator: yup.number().min(0, 'Min 0').max(100, 'Max 100'),
    description: `Input subsidies your project will receive here. Use the subsidy
               toggle on projections pages to see costs after subsidies are applied.`,
    getOperationsForCategory,
    getCapexesForOverride: (allCapexes) => allCapexes,
  },
};
